import { Context } from "../constants"
import { useAuthorized } from "../hooks/useAuthorized"
import { AuthorizedProps } from "../types"

/**
 * Component that only renders if the user has permissions to perform the action passed in *to*
 *
 * @component
 * @example
 *   <Authorized to={["create_hire"]} on={company}>
 *     Shows this if the user has permission to `create_hire` and `update_hire` on `company`
 *   </Authorized>
 */
export const Authorized = ({
  to,
  on,
  mode,
  context = Context.Actions,
  fallback,
  children,
}: AuthorizedProps) => {
  const { isAuthorized } = useAuthorized(on)
  const fallbackComponent = fallback || null

  return <>{isAuthorized(to, context, mode) ? children : fallbackComponent}</>
}
